const PrimaryButton = ({
  disabled = false,
  className = "",
  title,
  icon = null,
  type = "button",
  onClick,
  style = {},
  iconStyle = {},
  variant = "primary",
}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      type={type}
      style={style}
      className={["btn w-auto", className, `btn-${variant}`].join(" ")}
    >
      {icon && (
        <i
          className={[`${title ? "me-2" : ""}`, icon].join(" ")}
          style={iconStyle}
        ></i>
      )}
      {title}
    </button>
  );
};

export default PrimaryButton;
